import { useEffect, useState } from 'react'
import { BrandState } from 'state/brands'

//BrandDropdown used only subscriber to let template and editor can get the selected Brand immediately
// without set another 2 redundant sate in parent component
class BrandSelectionManager {
    private subscribers: Set<(brand: BrandState | null) => void>
    private selectedBrand: BrandState | null

    constructor(initialBrand: BrandState | null) {
        this.subscribers = new Set()
        this.selectedBrand = initialBrand
    }

    public subscribe(callback: (brand: BrandState | null) => void): void {
        this.subscribers.add(callback)
    }

    public unsubscribe(callback: (brand: BrandState | null) => void): void {
        this.subscribers.delete(callback)
    }

    public setSelectedBrand(brand: BrandState | null): void {
        this.selectedBrand = brand
        this.notifySubscribers()
    }

    public getSelectedBrand(): BrandState | null {
        return this.selectedBrand
    }

    private notifySubscribers(): void {
        for (const callback of this.subscribers) {
            callback(this.selectedBrand)
        }
    }
}

const brandSelectionManager = new BrandSelectionManager(null)

export const useSelectedBrand = () => {
    const [selectedBrand, setSelectedBrand] = useState<BrandState | null>(brandSelectionManager.getSelectedBrand())

    useEffect(() => {
        const updateSelectedBrand = (brand: BrandState | null) => setSelectedBrand(brand)
        brandSelectionManager.subscribe(updateSelectedBrand)
        return () => {
            brandSelectionManager.unsubscribe(updateSelectedBrand)
        }
    }, [])

    const updateBrandSelection = (brand: BrandState | null) => {
        brandSelectionManager.setSelectedBrand(brand)
    }

    return [selectedBrand, updateBrandSelection] as const
}
